import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon';
import Tooltip from '../../tooltip';

const COLOR_TILE_INDETERMINATE_TOOLTIP_ID = 'color-tile-indeterminate';

const IndeterminateTile = ({ className, tooltipText = null, isTouchDevice = false, onClick }) => (
  <>
    <div
      className={className}
      onClick={onClick}
      data-tip
      data-for={COLOR_TILE_INDETERMINATE_TOOLTIP_ID}
    >
      <Icon size="20" glyph="minus" withScaleFactor />
    </div>
    {!isTouchDevice && tooltipText && (
      <Tooltip id={COLOR_TILE_INDETERMINATE_TOOLTIP_ID} text={tooltipText} />
    )}
  </>
);

IndeterminateTile.propTypes = {
  className: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  isTouchDevice: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default IndeterminateTile;
